<template>
  <div :class="isMobile?'mobile-foot-send':'foot-send'">
    <div class="send-wrap">
      <div class="send-wrap-image">
        <img class="icon" src="@/assets/images/shangchuan.png" @click="changeUpload(isUpload)">
        <img class="icon" src="@/assets/images/yuyin.png" v-if="isVoice" @click="changeVoice">
        <img class="icon" src="@/assets/images/keyborad.png" v-if="isInput" @click="changeInput">
      </div>
      <div class="send-wrap-textarea">
        <textarea class="textarea-input" v-model.trim="message" maxlength="1000" :placeholder="lang.feedback.textareaDesc"></textarea>
        <div class="yuyin-input"></div>
      </div>
      <div class="send-wrap-button" @click="messageSend">{{ lang.feedback.footSend.send }}</div>
    </div>
    <div class="send-upload" v-if="isUpload">
      <feedback-upload v-model="imageList" :multiple="true" @change="imageChange"  :maxLength="imageLength" :token="this.gameUserinfo.token"></feedback-upload>
    </div>
  </div>
</template>

<script>
import {  mapGetters } from 'vuex'
import { FeedbackUpload } from '@/components'
export default {
  name: 'footSendMessage',
  components: {
    FeedbackUpload
  },
  computed: {
    ...mapGetters(['isMobile', 'feedbackQueryStr', 'lang', 'gameUserinfo'])
  },
  data () {
    return {
      isVoice: true,
      isInput: true,
      isUpload: false,
      imageList: [],
      imageLength: 5,
      message: ''
    }
  },
  created () {},
  methods: {
    changeInput () {
      this.isInput = false
      this.isVoice = true
    },
    changeVoice () {
      this.isInput = true
      this.isVoice = false
    },
    changeUpload (isUpload) {
      if (isUpload) {
        this.isUpload = false
      } else {
        this.isUpload = true
      }
    },
    imageChange () {
      if (this.imageList.length > 0) {
        let imgArr = []
        this.imageList.forEach((v) => {
          imgArr.push(v.url)
        })
        this.defaultForm.images = imgArr.join(',')
      } else {
        this.defaultForm.images = ''
      }
    },
    messageSend () {
      console.log(this.message)
    }
  }
}
</script>

<style lang="scss">

</style>
